module.exports = __webpack_public_path__ + "img/burmese-DE.39606edc.png";